import { MapProps, useMapProps } from '../types'
import useMapCenterMarker from './useMap.centerMarker'
import useMapInit from './useMap.init'

const useMap = ({
    center = {
        lat: 50.041671,
        lng: 14.475095,
    },
    ...rest
}: useMapProps): MapProps => {
    const initProps = useMapInit({ ...rest, center })
    const centerMarkerProps = useMapCenterMarker(initProps.mapObject, center, rest.onCenterChanged)

    return {
        map: initProps,
        centerMarker: centerMarkerProps,
    }
}
export default useMap
